import logo from './logo.svg';
import './App.css';
import Home from './Component/Home';

function App() {
  return (
    <>
    <Home/>
    </>
  );
}

export default App;
